import { render, staticRenderFns } from "./pi-message-recharge-box.vue?vue&type=template&id=302aeec8"
import script from "./pi-message-recharge-box.vue?vue&type=script&lang=ts"
export * from "./pi-message-recharge-box.vue?vue&type=script&lang=ts"
import style0 from "./pi-message-recharge-box.vue?vue&type=style&index=0&id=302aeec8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports